import React from 'react'
import { StatTableHeader } from './StatTableHeader'
import { StageStatsRow } from './StageStatsRow'
import { EmptyStatsRow } from './EmptyStatsRow'
import { UserPositions } from './UserPositions'
import { StampGroupRow } from './StampGroupRow'
import { StampMethodRow } from './StampMethodRow'
import { UserDailyProgress } from './UserDailyProgress'

export const UserStats = (
  {
    userStat,
    payload
  }
) => {
  const {
    stages,
    user,
    dailyProgress
  } = userStat || {}



  const stampMethodRender = (method) => {
    return (
      method.map((m) => {
        return (
          <StampMethodRow methodData={m}/>
        )
      })
    )
  }

  const stampsGroupRender = (stampGroups) => {
    return stampGroups.map((group) => {
      const groupItems = group.groupMethodsStats
      return (
        <div className={`my-[0.5rem]`}>
          <StampGroupRow key={group.groupCode} groupData={group}/>
          {stampMethodRender(groupItems)}
        </div>
      )
    })
  }

  const stagesRowsRender = (stages) => stages.map((stage) => {
    const isStampStage = stage.stampStage
    return (
      <div className={`my-[1rem]`}>
        <StageStatsRow key={stage.id} stageData={stage}/>
        {isStampStage && stampsGroupRender(stage.drawingsGroupsStats)}
      </div>
    )
  })


  return (
    <>
      <div className={`mt-[3.6rem] relative`}>
        <div
          className={`text-Regular(24_30) sticky top-[0] z-10 pt-[2rem] font-bold pb-[1rem] bg-Dominant/Dop`}>
          {user.username}
        </div>
        <div className={`relative`}>
          {!!stages.length && <StatTableHeader />}
          <div>
            {stages.length
              ? stagesRowsRender(stages)
              : <EmptyStatsRow
                text={'По данному сотруднику нет данных по примененным фильтрам'} />
            }
          </div>
        </div>
        {!!stages.length &&
          <UserPositions stages={stages} user={user} payload={payload} />}
      </div>
      {dailyProgress && <UserDailyProgress
        data={dailyProgress}
        stagesRowsRender={stagesRowsRender}
        user={user}
        payload={payload}
      />}
    </>

  )
}